




































import {Vue, Component, Watch} from "vue-property-decorator";

    import { AgoraQualityCheckerInterface } from "../../interfaces/AgoraQualityCheckerInterface";
    import { AgoraQualityChecker } from "../../agora/AgoraQualityChecker"
    import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import QualityIndicator from "@share/web-conferences/components/common/QualityIndicator.vue";
import RingLoader from "@share/common/RingLoader.vue";
import QualityTestMessage from "@share/web-conferences/components/quality-test/QualityTestMessage.vue";

    @Component({
        components: {QualityTestMessage, RingLoader, QualityIndicator }
    })

    export default class QualityTest extends Vue {
        qualityChecker: AgoraQualityCheckerInterface | null = null;
        cantStartTest = false;

        get uplinkQuality() {
            return this.qualityChecker?.uplinkClient?.averageQuality ?? -1;
        }

        get downlinkQuality() {
            return this.qualityChecker?.downlinkClient?.averageQuality ?? -1;
        }

        get isDone() {
            return this.uplinkQuality >= 0 && this.downlinkQuality >= 0;
        }

        get showLoader() {
            return !this.isDone && !this.cantStartTest;
        }

        get showResult() {
            return this.isDone && !this.cantStartTest;
        }

        mounted() {
            this.qualityChecker = new AgoraQualityChecker(
                this.$repositories.get(RepositoryFabric.WEB_CONFERENCE),
                this.$store
            );
            this.test();
        }

        async test() {
            const testResult = await this.qualityChecker?.test()
            if (!testResult) {
                //show message that it hasn't started
                console.log('cant start network test');
                this.cantStartTest = true;
            }
        }

        @Watch('isDone')
        async onIsDoneChanged() {
            if (this.isDone) {
                console.log('done');
                await this.qualityChecker?.clean();
            }
        }

        async destroyed() {
            await this.qualityChecker?.clean();
        }
    }
